import { z } from "zod";
export const createContractSchema = z.object({
    booking_id: z.uuid(),
    template_id: z.uuid().optional(),
});
